import React from "react";
import Sidebar from "../layouts/sidebar";
import Headers from "../layouts/header";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
// import Pagination from '@mui/material/Pagination';
// import PaginationItem from '@mui/material/PaginationItem';
// import {
//   DataGrid,
//   gridPageCountSelector,
//   gridPageSelector,
//   useGridApiContext,
//   useGridSelector,
// } from '@mui/x-data-grid';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import OrderStatus from "../layouts/OrderStatus";
import { useLocation } from "react-router";
import useAxiosFile from "../actions/useaxios";
import { useEffect } from "react";
import { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { DateTimeForm, DecryptData, NumberChange, isEmpty, returnArrayString } from "../actions/common";

import delpick from "../assests/images/delpick.png";
import QrReader from 'react-qr-reader';
import { IoMdCloseCircle } from "react-icons/io";


// function CustomPagination() {
//     const apiRef = useGridApiContext();
//     const page = useGridSelector(apiRef, gridPageSelector);
//     const pageCount = useGridSelector(apiRef, gridPageCountSelector);

//     return (

//       <Pagination
//         color="primary"
//         shape="rounded"
//         page={page + 1}
//         count={pageCount}
//         renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
//         onChange={(event, value) => apiRef.current.setPage(value - 1)}
//       />
//     );
//   }

function OrdersView() {
  const { payload, token } = useSelector((state) => state.admin_panel.User);

  const location = useLocation();
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const axiosfile = useAxiosFile();

  const [Id, Setid] = useState("");
  const [Detail, SetDetail] = useState({});
  const [Drivers, SetDrivers] = useState([]);
  const [Disabled, SetDisabled] = useState(false);
  const [SelectedDriver, SetSelectedDriver] = useState({});


  const [confirmmodel, setconfirmmodel] = useState(false);
  const [alertmodel, setalertmodel] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [showModal, SetShowModal] = useState(false)
  const [PackNumber, setPackNumber] = useState([]);
  const [number, setnumber] = useState('');
  const [position, setposition] = useState(false);
  const [orderdata, setOrderData] = useState([]);
  const [Options, Setoptions] = useState([]);
  const [status, Setselectstatus] = useState({});





  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid lightgray",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  function createData(no, orderid, name, type, date) {
    return { no, orderid, name, type, date };
  }

  const latestorders = [
    createData(1, "Coco Strawberry Pancake", "$9.49", "1", "$9.49"),
    createData(2, "Coco Strawberry Pancake", "$2.50", "2", "$5.00"),
    createData(3, "Coco Strawberry Pancake", "$2.50", "2", "$5.00"),
  ];
  // const columns = [
  //     { field: 'id', headerName: 'No', width: 90 },
  //     {
  //       field: 'product',
  //       headerName: 'Product',
  //       width: 140,
  //       editable: true,
  //     },
  //     {
  //       field: 'rate',
  //       headerName: 'Rate',
  //       width: 140,
  //       editable: true,
  //     },
  //     {
  //       field: 'quantity',
  //       headerName: 'Quantity',

  //       width: 140,
  //       editable: true,
  //     },
  //     {
  //       field: 'totals',
  //       headerName: 'Totals',
  //       width: 140,
  //       editable: true,
  //     },

  //   ];
  //   const rows = [
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action: <i class="fa-solid fa-ellipsis"/> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //     { id: '1', product: 'Snow', customerName: 'Jon', type: 'Delivery',payment:'Online',time:'1/17/2022  8:20 PM',amount:'$5.00',action:<i class="fa-solid fa-ellipsis"></i> },
  //   ];

  // const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  //     border: 0,
  //     color:
  //       theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
  //     fontFamily: [
  //       '-apple-system',
  //       'BlinkMacSystemFont',
  //       '"Segoe UI"',
  //       'Roboto',
  //       '"Helvetica Neue"',
  //       'Arial',
  //       'sans-serif',
  //       '"Apple Color Emoji"',
  //       '"Segoe UI Emoji"',
  //       '"Segoe UI Symbol"',
  //     ].join(','),
  //     WebkitFontSmoothing: 'auto',
  //     letterSpacing: 'normal',
  //     '& .MuiDataGrid-columnsContainer': {
  //       backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
  //     },
  //     '& .MuiDataGrid-iconSeparator': {
  //       display: 'none',
  //     },
  //     // '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
  //     //   borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
  //     //     }`,
  //     // },
  //     // '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
  //     //   borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
  //     //     }`,
  //     // },
  //     '& .MuiDataGrid-cell': {
  //       color:
  //         theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
  //         cursor:'default'
  //     },
  //     '& .MuiPaginationItem-root': {
  //       borderRadius: 0,
  //     },
  //     '& .MuiDataGrid-footerContainer': {
  //       display: "flex",
  //       justifyContent: "center"
  //     },

  //     ...customCheckbox(theme),
  //   }));

  //   function customCheckbox(theme) {
  //     return {
  //       '& .MuiCheckbox-root svg': {
  //         width: 16,
  //         height: 16,
  //         backgroundColor: 'transparent',
  //         border: `1px solid ${theme.palette.mode === 'light' ? '#d9d9d9' : 'rgb(67, 67, 67)'
  //           }`,
  //         borderRadius: 2,
  //       },
  //       '& .MuiCheckbox-root svg path': {
  //         display: 'none',
  //       },
  //       '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
  //         backgroundColor: '#e50914',
  //         borderColor: '#e50914',
  //       },
  //       '& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after': {
  //         position: 'absolute',
  //         display: 'table',
  //         border: '2px solid #fff',
  //         borderTop: 0,
  //         borderLeft: 0,
  //         transform: 'rotate(45deg) translate(-50%,-50%)',
  //         opacity: 1,
  //         transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
  //         content: '""',
  //         top: '50%',
  //         left: '39%',
  //         width: 5.71428571,
  //         height: 9.14285714,
  //       },
  //       '& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after': {
  //         width: 8,
  //         height: 8,
  //         backgroundColor: '#62626214',
  //         transform: 'none',
  //         top: '39%',
  //         border: 0,
  //       },

  //     };
  //   }

  useEffect(() => {
    if (location?.search) {
      let paramdata = location.search.split("?id=")[1];
      Setid(
        isEmpty(DecryptData(paramdata)) ? paramdata : DecryptData(paramdata)
      );
    }
  }, [location.search]);

  useEffect(() => {
    if (Id) {
      GetOrderDetail();
    }
  }, [Id, payload]);

  const GetOrderDetail = async () => {
    let Resp = await axiosfile.OrderDetail({ id: Id });
    if (Resp?.data?.Order?.CartId?.length > 0) {
      Resp.data.Order.CartId.map((val) => {
        if (val?.AdditionalInfo?.length > 0) {
          val.AdditionalInfo.map((modifier) => {
            if (val?.modifier?.[modifier?.question]) {
              val.modifier[modifier?.question] = val.modifier[modifier?.question]?.replace(".", ", ") + modifier?.value + "."
            }
            else {
              val.modifier = { [modifier?.question]: modifier?.value + "." }
            }
          })
        }
      })
    }
    SetDetail(Resp?.data?.Order);
    if (Resp?.data?.Order?.Driver) {
      Resp.data.Order.Driver.label = Resp?.data?.Order?.Driver?.FirstName;
      Resp.data.Order.Driver.value = Resp?.data?.Order?.Driver?.FirstName;
      SetSelectedDriver(Resp?.data?.Order?.Driver);
    }
  };

  const OrderAction = async (action) => {
    SetDisabled(true);
    if (!Disabled) {
      let toastid = toast.loading("Updating")
      let senddata = {
        OrderId: Detail._id,
        Status: action,
      };
      let Resp = await axiosfile.OrderStatusUpdate(senddata);
      if (Resp?.success == "success") {
        toast.update(toastid, { render: "Status Updated Successfully", type: "success", isLoading: false, autoClose: 1000 })
        // toast.success("Status Updated Successfully");
      } else {
        toast.update(toastid, { render: Resp?.msg, type: "error", isLoading: false, autoClose: 1000 })
        // toast.error(Resp?.msg);
      }
      GetOrderDetail();
      handlealertClose()
      handlecomfirmClose()
      handleClose()
    }
    else {
      return true
    }
    SetDisabled(false)
  };

  useEffect(() => {
    GetDrivers();
  }, []);

  const GetDrivers = async () => {
    let Resp = await axiosfile.GetDriver({ status: true });
    if (Resp?.data?.length > 0) {
      SetDrivers(Resp.data);
    }
  };

  const ChooseDriver = async () => {
    if (SelectedDriver?._id) {
      let Resp = await axiosfile.AssignDriver({
        Order: Id,
        Driver: SelectedDriver?._id,
      });
      console.log("sdfgergrgreg", Resp);
      if (!isEmpty(Resp?.data)) {
        toast.success("Driver Assigned");
      } else {
        toast.error("Error Occured");
      }
    } else {
      toast.error("Choose Driver");
    }
  };

  const handleClose = () => {
    SetShowModal(false);
  }

  const handlecomfirmClose = () => {
    setconfirmmodel(false);
  }
  const handlealertClose = () => {
    setalertmodel(false);
  }

  const Submit = (data, from) => {
    // console.log("orderdataorderdata", data, from);
    setsubmit(true)
    if (from == 'scanner') {
      if (PackNumber?.length > 0) {
        OrderAction(data)

      } else {
        toast.error("Enter the package numbers")

        // HandleShowModal()

      }
      setsubmit(false)

    }
    else {
      OrderAction(data)
      setsubmit(false)

    }


  }
  const orderStatuschange = (data) => {
    Setselectstatus(data)
    if (data?.value == "qrscan") {
      setconfirmmodel(true)
    }
    else {
      OrderAction(data?.value)
    }

  }


  const handleChange = (e) => {

    if (e?.length > 20) {
      return toast.error("Only 20 charcters are allowed...!")
    }
    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e)])

      }
    }
    setnumber('')

  };
  const Cancelpackage = (index) => {
    setPackNumber([
      ...PackNumber.slice(0, index),
      ...PackNumber.slice(index + 1, PackNumber?.length),


    ])

  }
  const Switchcamera = () => {
    setposition(!position);
    SetShowModal(false)
    setTimeout(() => {
      SetShowModal(true)

    }, 200);
  }
  const handleError = (data) => {
    console.log(
      "handleErrorhandleError", data
    );
  }
  const handleScan = (e) => {
    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e)])

      }
    }

  };

  useEffect(() => {
    let Optionsdata = []
    if (isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned)) {

      Optionsdata.push({ label: "Accept", value: 'approvebyseller' })
    }
    if (!isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.Dispatch) && isEmpty(Detail?.Time?.preparing) && isEmpty(Detail?.Time?.returned)) {

      Optionsdata.push({ label: "Preparing", value: 'preparing' })

    }
    if (!isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned) && isEmpty(Detail?.Time?.Dispatch) && Detail?.OrderType == 'Pickup') {

      Optionsdata.push({ label: "Order Is Ready", value: 'picked' })

    }
    if (!isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned) && isEmpty(Detail?.Time?.Dispatch) && Detail?.OrderType !== 'Pickup') {

      Optionsdata.push({ label: "Order Is Ready", value: 'qrscan' })

    }
    if (isEmpty(Detail?.Time?.completed) && isEmpty(Detail?.Time?.Shipping) && isEmpty(Detail?.Time?.returned) && !isEmpty(Detail?.Time?.Dispatch) && isEmpty(Detail?.Time?.Pickup) && Detail?.OrderType !== 'Pickup') {

      Optionsdata.push({ label: "Pickup", value: 'picked' })

    }
    if (isEmpty(Detail?.Time?.Dispatch) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned)) {
      Optionsdata.push({ label: "Cancel Order", value: 'cancelbyseller' })

    }
    Setoptions(Optionsdata)
  }, [Detail])


  useEffect(() => {

    if (Detail?.Status == 'preparing') {
      Setselectstatus({ label: "Preparing", value: 'preparing' })
    }
    else if (Detail?.Status == 'approvebyseller') {
      Setselectstatus({ label: "Accept", value: 'approvebyseller' })
    }
    else if (Detail?.Status == 'picked') {
      Setselectstatus({ label: "Order Is Ready", value: 'picked' })
    }
    else if (Detail?.Status == 'preparing') {
      Setselectstatus({ label: "Order Is Ready", value: 'dispatch' })
    }
    else if (Detail?.Status == 'cancelbyseller') {
      Setselectstatus({ label: "Cancel Order", value: 'cancelbyseller' })
    }
    else if (Detail?.Status == 'dispatch') {
      Setselectstatus({ label: "Dispatch", value: 'dispatch' })
    }

  }, [Detail])
  console.log("statusstatus", status);

  return (
    <>

      <section id="content-wrapper">
        <Row className="mx-auto">
          <Col xxl={9} xl={9} lg={8} md={12} sm={12} xs={12}>
            <div className="rv_rowborder">
              <div className="logo_invoice d_bloc logo_inv_co">
                {/* <img
                              className="mainlogo_al"
                              src={require("../assests/images/jamske.png")}
                            /> */}
                {/* {console.log('DetailDetailDetail',Detail)} */}
                <img
                  className="mainlogo_al wd_ht_unst"
                  src={delpick}
                  alt="calender"
                />
                <p className="invoice_txt mt-3 mt-sm-0">
                  OrderId : <b>#{Detail?.OrderNumber}</b>
                </p>
              </div>
              <div className="ov_adrsdate_dtls d_bloc">
                <p className="ov_address">
                  {
                    !isEmpty(Detail?.ShopId?.Address?.FullAddress)
                      ?
                      <>
                        {Detail?.ShopId?.Address?.FullAddress}
                      </>
                      :
                      <>
                        {Detail?.ShopId?.Address?.StreetNumber
                          ? Detail?.ShopId?.Address?.StreetNumber + ","
                          : ""}
                        {Detail?.ShopId?.Address?.StreetName
                          ? Detail?.ShopId?.Address?.StreetName + ","
                          : ""}
                        {Detail?.ShopId?.Address?.City
                          ? Detail?.ShopId?.Address?.City + ","
                          : ""}
                        {Detail?.ShopId?.Address?.Country
                          ? Detail?.ShopId?.Address?.Country + "-"
                          : ""}
                        {Detail?.ShopId?.Address?.Zipcode
                          ? Detail?.ShopId?.Address?.Zipcode
                          : ""}
                      </>
                  }
                  <br />
                  {Detail?.ShopId?.Mobile}
                  <br />
                  {Detail?.ShopId?.EmailId}
                </p>

                <div className="ov_adrsdate_right mt-4 mt-sm-0">
                  <div>
                    <p className="ov_address">Date Issued : </p>
                    <p className="ov_address mt-2">Time : </p>
                  </div>
                  <div>
                    <p className="value_datetime">
                      {DateTimeForm(Detail?.createdAt, true)}
                    </p>
                    <p className="value_datetime mt-2">
                      {DateTimeForm(
                        Detail?.createdAt,
                        undefined,
                        true,
                        true
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="ov_invoicepayment_dtls d_bloc_lg">
                {Detail?.OrderType?.toLocaleLowerCase() == "delivery" &&
                  <div className="ov_invoicepayment">
                    <p>Invoice to</p>
                    <p className="ov_invoicename mt-2">
                      {Detail?.DeliveryAddress?.FullName}
                      <br />
                      {Detail?.DeliveryAddress?.Mobile}
                    </p>
                    <p className="mt-2">
                      {
                        !isEmpty(Detail?.Address?.FullAddress) ?
                          <>{Detail?.Address?.FullAddress}</>


                          : (isEmpty(Detail?.Address) ? (
                            <>
                              {Detail?.DeliveryAddress?.Doornumber
                                ? Detail?.DeliveryAddress?.Doornumber +
                                ","
                                : ""}
                              {Detail?.DeliveryAddress?.Street
                                ? Detail?.DeliveryAddress?.Street + ","
                                : ""}
                              {Detail?.DeliveryAddress?.Street2
                                ? Detail?.DeliveryAddress?.Street2 + ","
                                : ""}
                              <br />
                              {Detail?.DeliveryAddress?.City
                                ? Detail?.DeliveryAddress?.City + ","
                                : ""}
                              {Detail?.DeliveryAddress?.Area
                                ? Detail?.DeliveryAddress?.Area + ","
                                : ""}
                              -
                              {Detail?.DeliveryAddress?.Zipcode
                                ? Detail?.DeliveryAddress?.Zipcode + ","
                                : ""}
                              <br />
                              {Detail?.DeliveryAddress?.Mobile}
                              <br />
                              {Detail?.DeliveryAddress?.EmailId}
                            </>
                          ) : (
                            <>
                              {Detail?.Address?.Doornumber
                                ? Detail?.Address?.Doornumber + ","
                                : ""}
                              {Detail?.Address?.Street
                                ? Detail?.Address?.Street + ","
                                : ""}
                              {Detail?.Address?.Street2
                                ? Detail?.Address?.Street2 + ","
                                : ""}
                              <br />
                              {Detail?.Address?.City
                                ? Detail?.Address?.City + ","
                                : ""}
                              {Detail?.Address?.Area
                                ? Detail?.Address?.Area + ","
                                : ""}
                              -
                              {Detail?.Address?.Zipcode
                                ? Detail?.Address?.Zipcode + ","
                                : ""}
                              <br />
                              {Detail?.Address?.Mobile}
                              <br />
                              {Detail?.Address?.EmailId}
                            </>
                          ))
                      }
                    </p>
                  </div>}
                <div className="mb-4">
                  <p className="ov_paymentdtl_title mar_tp_lg">
                    Payment Details
                  </p>
                  <div className="ov_paymentdtls payment_width">
                    <div>
                      <p className="ov_address wht_spc_nowrap">
                        Total Amount
                      </p>
                      <p className="ov_address mt-2 wht_spc_nowrap">
                        Status
                      </p>
                      {Detail?.Time?.Paid && (
                        <p className="ov_address mt-2 wht_spc_nowrap">
                          Transaction ID
                        </p>
                      )}
                      <p className="ov_address ov_address_wrap mt-2">
                        Delivery Time {Detail?.DeliveryStartTime ? "between" : "before"}
                      </p>
                    </div>
                    <div>
                      <p className="value_datetime">
                        : {Detail?.ShopId?.CurrencySymbol}
                        {Detail?.Price?.PayAmount}
                      </p>
                      <p className="value_datetime greentxt mt-2">
                        : {isEmpty(Detail?.Time?.Paid)
                          ? "Pending"
                          : "Paid"}
                      </p>
                      {Detail?.Time?.Paid && (
                        <p className="value_datetime mt-2 ms-1">
                          : #{Detail?.TransactionHistory?.object?.id}
                        </p>
                      )}
                      <p className="value_datetime mt-2 val_date_time_nowrap">
                        : {Detail?.DeliveryStartTime ? (DateTimeForm(new Date(Detail?.DeliveryStartTime), undefined, undefined, true) + "-") : ""}
                        {DateTimeForm(new Date(Detail?.DeliveryTime), undefined, undefined, true)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className='order_tables_cmn'>
                  <StyledDataGrid
                    
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    rows={rows}
                    columns={columns}
                    components={{
                      Pagination: CustomPagination,
                    }}
                    className='campaign_muitbl'
                   

                  />


                </div> */}

              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="order_table"
                >
                  <TableHead>
                    <TableRow className="ov_tablehead">
                      <TableCell>No</TableCell>
                      <TableCell align="left">Product</TableCell>
                      {/* <TableCell align="left">Rate</TableCell> */}
                      <TableCell align="center">Notes</TableCell>
                      <TableCell align="center">Modifiers</TableCell>
                      <TableCell align="left">Quantity</TableCell>
                      <TableCell align="left">Totals</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Detail?.CartId?.length > 0 &&
                      Detail?.CartId?.map((latestorders, ind) => (
                        <TableRow
                          className="ov_tabledtls"
                          key={latestorders._id}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          {console.log('latestorderslatestorders', latestorders)}
                          <TableCell component="th" scope="row">
                            {ind + 1}
                          </TableCell>
                          <TableCell align="left">
                            {latestorders?.ProductId?.ProductName}
                          </TableCell>
                          {/* <TableCell align="left">
                                        {Detail?.ShopId?.CurrencySymbol}{" "}
                                        {latestorders?.ProductId?.Price}
                                      </TableCell> */}
                          <TableCell align="left">
                            {
                              (Array.isArray(latestorders?.Notes) && latestorders?.Notes?.length > 0)
                                ?
                                <>
                                  {
                                    returnArrayString(latestorders?.Notes, undefined, undefined, undefined, 'notes')
                                  }
                                </>
                                :
                                <p className="text-center">No Notes</p>
                            }
                            {console.log('latestorderslatestorders', latestorders, Detail)}
                          </TableCell>
                          <TableCell align="left">
                            {
                              (latestorders?.modifier && Object.keys(latestorders?.modifier)?.length > 0) ?
                                Object.keys(latestorders?.modifier)?.map((val) => {
                                  return (
                                    <p className="d-flex align-items-center justify-content-between conten_modi">
                                      <span>
                                        {val}
                                      </span>
                                      <span>:</span>

                                      <span>{latestorders?.modifier?.[val]}</span></p>
                                  )
                                })
                                :
                                <p className="text-center">No Modifers</p>

                            }
                          </TableCell>
                          <TableCell align="left">
                            {latestorders.Quantity}
                          </TableCell>
                          <TableCell align="left">
                            {Detail?.ShopId?.CurrencySymbol}{" "}
                            {NumberChange(latestorders?.TotalPrice)?.toFixed(2)}
                          </TableCell>
                          {/* <TableCell className='price_clr' align="center">{latestorders.price} <i class="fa fa-angle-right" aria-hidden="true"></i></TableCell> */}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>


              <div className="ov_totalamnt_full">
                <div className="ov_bottomsug">
                  {Detail?.DeliveryAddress?.Instructions && (
                    <>
                      <p className="ov_totalamnt_left mt-0 left_tetx_ins">
                        Instructions for delivery person:
                      </p>
                      <p className="ov_address left_tetx_ins tetx_earp_add">
                        {Detail?.DeliveryAddress?.Instructions}
                      </p>
                    </>
                  )}
                  {Detail?.DeliveryAddress?.Addresslabel && (
                    <>
                      <p className="ov_totalamnt_left left_tetx_ins">
                        Address Label:
                      </p>
                      <p className="ov_address left_tetx_ins tetx_earp_add">
                        {Detail?.DeliveryAddress?.Addresslabel}
                      </p>
                    </>
                  )}
                </div>
                <div className="ov_totalamnt_whole">
                  <div className="ov_totalamnt_top">
                    <div>
                      <p className="ov_address">Subtotal</p>
                      <p className="ov_address mt-2">Taxes</p>
                      <p className="ov_address mt-2">Commission</p>

                      {/* <p className='ov_address mt-2'>{Detail?.couponDetails?.DiscountInPercentange == "" ? <></> : `Discount(${Detail?.couponDetails?.DiscountInPercentange + "%"})` ? Detail?.couponDetails?.DiscountInPrice == "" ? <></> : `Discount(${Detail?.ShopId?.CurrencySymbol}{" "}${Detail?.couponDetails?.DiscountInPrice})`}</p> */}

                      {/* //  <p className='ov_address mt-2'>{Detail?.couponDetails?.DiscountInPercentange == "" ? <></> : `Discount(${Detail?.couponDetails?.DiscountInPercentange + "%"})` ? Detail?.couponDetails?.DiscountInPrice == "" ? <></> : `Discount(${Detail?.ShopId?.CurrencySymbol}{" "}${Detail?.couponDetails?.DiscountInPrice})`}</p> */}
                      {Detail?.Coupon &&
                        <p className='ov_address mt-2'>{Detail?.couponDetails?.DiscountInPercentange ? `Discount(${Detail?.couponDetails?.DiscountInPercentange + "%"})` : `Discount(${Detail?.ShopId?.CurrencySymbol}${Detail?.couponDetails?.DiscountInPrice})`}</p>

                      }

                      <p className="ov_address mt-2">Seller Tip</p>
                      {Detail?.Price?.DriverTipsInValue ? (
                        <p className="ov_address mt-2">
                          Driver Tip
                        </p>
                      ) : ''
                      }
                    </div>
                    <div>
                      <p className="value_datetime">
                        {Detail?.ShopId?.CurrencySymbol}{" "}
                        {NumberChange(Detail?.Price?.CartValue).toFixed(
                          2
                        )}
                      </p>


                      <p className="value_datetime mt-2">
                        {Detail?.ShopId?.CurrencySymbol}{" "}
                        {NumberChange(Detail?.Price?.Taxes).toFixed(2)}
                      </p>
                      <p className="value_datetime mt-2">
                        {Detail?.ShopId?.CurrencySymbol}{" "}
                        {Detail?.Price?.DeliveryTimeCharges}
                      </p>
                      {/* <p className='value_datetime mt-2'>$0.49</p> */}
                      {Detail?.Coupon &&
                        <>
                          {Detail?.couponDetails?.discountPrice == "" ?
                            <></>
                            :
                            <p className="value_datetime mt-2">
                              {Detail?.ShopId?.CurrencySymbol}{" "}
                              {NumberChange(Detail?.couponDetails?.discountPrice).toFixed(
                                2
                              )}
                            </p>}
                        </>
                      }
                      {/* {Detail.Coupon && 
                                  <>
                                  {Detail?.couponDetails?.discountPrice == "" ?
                                   <></>
                                    :
                                    <p className="value_datetime mt-2">
                                      {Detail?.ShopId?.CurrencySymbol}{" "}
                                      {Number(Detail?.couponDetails?.discountPrice).toFixed(
                                        2
                                      )}
                                    </p>

                                  }
                                  </>
                                  } */}


                      <p className="value_datetime mt-2">
                        {Detail?.ShopId?.CurrencySymbol}{" "}
                        {NumberChange(
                          Detail?.Price?.SellerTipsInValue
                        ).toFixed(2)}
                      </p>
                      {Detail?.Price?.DriverTipsInValue ? (
                        <p className="value_datetime mt-2">
                          {Detail?.ShopId?.CurrencySymbol}{" "}
                          {NumberChange(
                            Detail?.Price?.DriverTipsInValue
                          ).toFixed(2)}
                        </p>
                      )
                        : ''
                      }
                    </div>
                  </div>
                  <div className="ov_totalamnt_bottom">
                    <p className="ov_totalamnt_left">
                      Total Amount
                    </p>
                    <p className="ov_totalamnt_right">
                      {Detail?.ShopId?.CurrencySymbol}{" "}
                      {(Detail?.Price?.PayAmount ? NumberChange(Detail?.Price?.PayAmount).toFixed(2) : '0')}
                    </p>
                  </div>
                </div>
              </div>
            </div>


            {(Detail?.OrderType == "Delivery" && Detail?.Time?.ApprovedBySeller) && (
              <div className="rv_rowborder mt-3">
                {SelectedDriver?.FirstName && (
                  <p className="ov_paymentdtl_title mar_tp_lg">
                    Choose Driver For Pickup
                  </p>
                )}
                <div className="mt-3">
                  <Select
                    value={isEmpty(SelectedDriver) ? { label: "Select Driver", value: "Select Driver" } : SelectedDriver}
                    options={Drivers}
                    styles={stylesgraybg}
                    onChange={(e) => SetSelectedDriver(e)}
                    isDisabled={
                      (Detail?.Time?.Pickup ||
                        Detail?.Status == "completed" ||
                        !Detail?.Time?.ApprovedBySeller ||
                        Detail?.Time?.cancelbyseller ||
                        Detail?.Time?.cancelbyuser
                      )
                        ? true
                        : false
                    }
                  />
                </div>

                <div className="ov_paymentdtls payment_width">
                  <div>
                    <p className="ov_address wht_spc_nowrap">
                      Driver Name
                    </p>
                    <p className="ov_address mt-2 wht_spc_nowrap">
                      Email-Id
                    </p>
                    <p className="ov_address mt-2 wht_spc_nowrap">
                      Mobile
                    </p>
                  </div>
                  <div>
                    <p className="value_datetime no_wrap_tx_rig">
                      : {SelectedDriver?.FirstName}{" "}
                      {SelectedDriver?.LastName}
                    </p>
                    <p className="value_datetime greentxt mt-2 no_wrap_tx_rig">
                      : {SelectedDriver?.EmailId}
                    </p>
                    <p className="value_datetime mt-2 no_wrap_tx_rig">
                      : {SelectedDriver?.Mobile}
                    </p>
                  </div>
                </div>

                {
                  !(Detail?.Time?.Pickup ||
                    Detail?.Status == "completed" ||
                    !Detail?.Time?.ApprovedBySeller ||
                    Detail?.Time?.cancelbyseller ||
                    Detail?.Time?.cancelbyuser
                  ) && (
                    <button
                      className="blue_btn add_deliveryprsn mt-4 dp_btn_hover"
                      onClick={() => ChooseDriver()}
                      type="button"
                    >
                      Select Driver
                    </button>
                  )}
              </div>
            )}
          </Col>
          <Col
            xxl={3}
            xl={3}
            lg={4}
            md={12}
            sm={12}
            xs={12}
            className="ov_reducepad pe-0"
          >
            {/* <Select
                            options={Options}
                            defaultValue={status}
                            value={status}
                            onChange={(data) => orderStatuschange(data)}
                            placeholder='Status'
                            styles={stylesgraybg}
                            isSearchable={false}
                          /> */}
            <OrderStatus
              Orderdata={Detail}
              OrderAction={OrderAction}
              setconfirmmodel={setconfirmmodel}
              setOrderData={setOrderData}
            />
          </Col>
        </Row>
      </section>


      {showModal &&
        <Modal
          show={showModal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Scan the Qr code to add the package number
            </Modal.Title>
            {/* <Modal.Title></Modal.Title> */}

          </Modal.Header>
          <Modal.Body>


            <QrReader
              delay={1000}
              onError={handleError}
              onScan={(e) => handleScan(e)}
              style={{ width: '100%', height: "100%" }}
              constraints={{ facingMode: position ? 'environment' : "user" }}

            />


            <div className="rv_rowborder mt-3">
              {/* {PackNumber?.map((item) =>
            <text>{item}</text>
          )
          } */}
              <div className="d-flex align-items-center gap-2 flex-wrap scantagsec ">
                {PackNumber?.map((item, index) =>
                  <p className="mb-0 labeltags">{item} <IoMdCloseCircle className="closeicons" onClick={() => Cancelpackage(index)} /></p>
                )
                }

              </div>
              <div className="text-center">
                <p>
                  Enter Manually
                </p>
                <div className="d-flex align-items-center gap-3 justify-content-center mb-3">

                  <input type="text" value={number} onChange={(e) => setnumber((e.target.value).trim())} maxLength={50} />
                  {
                    <button
                      className="blue_btn add_deliveryprsn mt-0 dp_btn_hover ml-2"
                      type="button"
                      onClick={() => handleChange(number)}
                    >
                      Add
                    </button>
                  }
                </div>

              </div>

              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => !submit && Submit('dispatch', 'scanner')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { Switchcamera() }}
                  >
                    Switch camera
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }


      {confirmmodel &&
        <Modal
          show={confirmmodel}
          onHide={handlecomfirmClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Order for Delivery
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>

            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { SetShowModal(true); handlecomfirmClose() }}
                  >
                    Scan the Qr
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { setalertmodel(true); handlecomfirmClose() }}
                  >
                    Dispatch
                  </button>
                }

              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
      {alertmodel &&
        <Modal
          show={alertmodel}
          onHide={handlealertClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}> Your item will be packed by the delivery person,Are you sure want to confirm?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => !submit && Submit('dispatch', 'manual')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { handlealertClose() }}
                  >
                    Cancel
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }

    </ >
  );
}

export default OrdersView;
